import { validateStorageShape } from './validateStorageShape';
import { getSessionStorageKey } from '../TaskQueueBar/utils/getSessionStorageKey';
export function clearTaskQueueConfig(storage) {
  validateStorageShape(storage);
  const storageKey = getSessionStorageKey();
  storage.removeItem(storageKey);
}